export default __webpack_public_path__ + "static/media/particle-loop-transparent.db5c176d.gif";